import styled from "styled-components";

const Description = styled.p`
	font-size: 20px;
	font-weight: bold;
	text-align: ${props => props.align};
`;

export default Description;
